// @mui material components
import Icon from "@mui/material/Icon";

// Pages
import Presentation from "pages/Presentation";
import Somos from "pages/LandingPages/Somos";
import Productos from "pages/LandingPages/Productos";
import ServicioTecnico from "pages/LandingPages/ServicioTecnico";
import Contactanos from "pages/LandingPages/Contactanos";

const routes = [
  {
    name: "Inicio",
    icon: <Icon>home</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    route: "/inicio",
    component: <Presentation />
  },
  {
    name: "Somos",
    icon: <Icon>groups</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    route: "/somos",
    component: <Somos />
  },
  {
    name: "Productos",
    icon: <Icon>list</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    route: "/productos",
    component: <Productos />
  },
  {
    name: "Servicio Técnico",
    icon: <Icon>engineering</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    route: "/servicio",
    component: <ServicioTecnico />
  },
  {
    name: "Contactanos",
    icon: <Icon>email</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    route: "/contactanos",
    component: <Contactanos />
  }
];

export default routes;
